















import Vue from "vue";
// import { apiUrl } from "@/domain";
// import ImageCompressor from "compressorjs";
import HeaderComponent from "@/components/HeaderComponent.vue";
import ApiService from "@/services/ApiService";
export default Vue.extend({
  name: "wondeLogsModal",
  data() {
    return {
      columns: [
        {
          label: "Action",
          field: "action",
          width: "150px",
        },
        {
          label: "Description",
          field: "description",
        },
        {
          label: "Param1",
          field: "param1",
        },
        {
          label: "Param2",
          field: "param2",
        },
        {
          label: "School_id",
          field: "school_id",
          type: "number",
        },
        {
          label: "Updated at",
          field: "updated_at",
          width: "140px",
          // type: "date",
          // dateInputFormat: "yyyy-MM-dd",
          // dateOutputFormat: "MMM do yy",
        },
      ],
      rows: [],
      filterText: "",
    };
  },
  components: {
    HeaderComponent,
  },
  props: {
    id: Number,
    new: Boolean,
  },
  computed: {
    filteredRows() {
      return this.rows.filter((itm) => {
        if (!this.filterText) {
          return itm;
        } else {
          return (
            itm.action?.includes(this.filterText) ||
            itm.description?.includes(this.filterText) ||
            itm.param1?.includes(this.filterText) ||
            itm.param2?.includes(this.filterText)
          );
        }
      });
    },
  },
  methods: {
    loadMiLogs() {
      ApiService.sadminApi.getMiLogs({}).then((resp) => {
        this.rows = resp.data;
      });
    },
  },
  mounted() {
    this.loadMiLogs();
  },
});
